import React, { useState, useEffect } from 'react'; // Thêm useEffect
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Button, IconButton,
  Container, Menu, MenuItem, ListItemIcon, ListItemText, Box
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ArticleIcon from '@mui/icons-material/Article';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';

function MainNavBar() {
  // Thay đổi state: dùng anchorEl để xác định vị trí mở menu thay vì boolean drawerOpen
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  // 1. KHAI BÁO THÊM userRole
  const [displayName, setDisplayName] = useState(null);
  const [userRole, setUserRole] = useState('SALE'); 

  // 2. CẬP NHẬT useEffect ĐỂ LẤY ROLE TỪ LOCAL STORAGE
  useEffect(() => {
    const name = localStorage.getItem('user_display_name'); 
    const role = localStorage.getItem('user_role') || 'SALE'; 

    if (name) setDisplayName(name);
    setUserRole(role); // Gán role vào state
  }, []);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Xử lý đăng xuất
  const handleLogout = () => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_display_name');
      localStorage.removeItem('is_manager');
      localStorage.removeItem('user_role'); // Thêm dòng này
      setDisplayName(null);
      setUserRole('SALE'); // Thêm dòng này
      navigate('/login');
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#007373' }}>
      <Container maxWidth={false} sx={{ maxWidth: '1400px'}}>
        <Toolbar disableGutters>
          {/* Nút Menu kích hoạt Popover */}
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleMenuClick}
          >
            <MenuIcon />
          </IconButton>

          {/* Component Menu (Popover) */}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
          >
            {/* Form Nhập/Sửa: Hiện cho SALE, OPERATOR, MANAGER */}
            {['SALE', 'OPERATOR', 'MANAGER'].includes(userRole) && (
              <MenuItem component={RouterLink} to="/form" onClick={handleMenuClose}>
                <ListItemIcon><ArticleIcon fontSize="small" /></ListItemIcon>
                <ListItemText>Form Nhập/Sửa</ListItemText>
              </MenuItem>
            )}

            {/* Điều hành: Chỉ hiện cho OPERATOR, MANAGER */}
            {['OPERATOR', 'MANAGER'].includes(userRole) && (
              <MenuItem component={RouterLink} to="/dashboard" onClick={handleMenuClose}>
                <ListItemIcon><DashboardIcon fontSize="small" /></ListItemIcon>
                <ListItemText>Điều hành</ListItemText>
              </MenuItem>
            )}

            {/* Quản trị: Hiện cho ACCOUNTANT, MANAGER */}
            {['ACCOUNTANT', 'MANAGER'].includes(userRole) && (
              <MenuItem component={RouterLink} to="/management" onClick={handleMenuClose}>
                  <ListItemIcon><DashboardIcon fontSize="small" color="secondary" /></ListItemIcon>
                  <ListItemText>Quản trị</ListItemText>
              </MenuItem>
            )}

            {/* Quản lý Nguồn cung: Chỉ hiện cho SOURCING, MANAGER */}
            {['MANAGER', 'SOURCING'].includes(userRole) && (
              <MenuItem component={RouterLink} to="/resources" onClick={handleMenuClose}>
                  <ListItemIcon><DashboardIcon fontSize="small" color="secondary" /></ListItemIcon> 
                  <ListItemText>Quản lý Nguồn cung</ListItemText>
              </MenuItem>
            )}
          </Menu>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, fontWeight: 'bold' }}
          >
            CRM FOLA TRAVEL
          </Typography>
          {/* --- LOGIC HIỂN THỊ NÚT ĐĂNG NHẬP / ĐĂNG XUẤT --- */}
          {displayName ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2" sx={{ mr: 2 }}>
                Hi, {displayName}
              </Typography>
              <Button color="inherit" startIcon={<LogoutIcon />} onClick={handleLogout}>
                Đăng xuất
              </Button>
              </Box>
            ) : (
              <Button color="inherit" component={RouterLink} to="/login">
                Đăng nhập
              </Button>
            )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default MainNavBar;